/**
 * 检查值是否为普通对象（由 Object 构造函数创建或对象字面量创建的对象）
 * @param value - 要检查的值
 * @returns 如果值是普通对象返回 true，否则返回 false
 * @example
 * ```ts
 * isPlainObject({}); // => true
 * isPlainObject({ a: 1 }); // => true
 * isPlainObject(Object.create(null)); // => true
 * isPlainObject([]); // => false
 * isPlainObject(null); // => false
 * isPlainObject(new Date()); // => false
 * isPlainObject(new Map()); // => false
 * ```
 */
export function isPlainObject(
  value: unknown,
): value is Record<string, unknown> {
  if (value === null || typeof value !== "object") {
    return false;
  }

  // 检查是否为普通对象（非数组、非 null、非特殊对象）
  const proto = Object.getPrototypeOf(value);
  return proto === null || proto === Object.prototype;
}
